<template>
  <div>
    <template>
      <h2 class="title">
        {{ product.payload.product }}
        <font-awesome-icon class="text-primary" :icon="['far', 'fire']" :style="iconStyle"></font-awesome-icon>
      </h2>
      <p class="message">
        {{ product.payload.description }}
      </p>
      <div class="views-details">
        <div class="views text-center">
          <p class="view-count font-weight-bold">
            {{ product.payload.data.views }}
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['GETTING-NOTICED']}.views`
              )
            }}
          </p>
          <p class="date-range">
            {{
              $t(
                `message.spotlightV2.categories.highlights.${enums.SpotlightConstants.internalNames.autoverify['GETTING-NOTICED']}.dateRange`
              )
            }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'GettingNoticed',

  data() {
    return {
      iconStyle: {
        fontSize: '21px',
      },
    };
  },
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.views-details {
  border-radius: 4px;
  background: rgb(240, 244, 247);
  padding: 12px 52px;
  max-width: 335px;
  margin: auto;
  p {
    margin: 4px auto;
  }
}
.view-count {
  color: $primary;
  font-size: 22px;
}
.date-range {
  color: rgb(25, 34, 43);
}
.message {
  padding-bottom: 10px;
}

@media only screen and (min-width: 576px) {
  .view-count {
    font-size: 28px;
  }
  .message {
    padding-bottom: 20px;
  }
}
</style>
